import 'jquery-ui/ui/widget'
import 'jquery-ui/ui/widgets/accordion'
import $ from 'jquery'

class Faqs {
  constructor(element) {
    if (!element) {
      return false
    }

    this.wrap = jQuery(element)

    this.initAcc()
  }

  initAcc() {
    this.wrap.accordion({
      active: 'none',
      collapsible: true,
      heightStyle: 'content',
     
    })
  }
}
export default Faqs
